import axios from 'axios'
import { getUserToken } from '@/utils/cookies'
import store from '@/store'
import secret from './secret'

const defauleTimeOut = 1000 * 20
const axiosService = axios.create({
  timeout: defauleTimeOut,
  retry: 5, //设置全局重试请求次数（最多重试几次请求）
  retryDelay: 1000 //设置全局请求间隔
})
axiosService.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// if (!(xtoken == null)) {
//   axiosService.defaults.headers.post['token'] = xtoken
// }

// http request 拦截器
axiosService.interceptors.request.use(
  config => {
    let xtoken = getUserToken()
    xtoken = (xtoken === 'undefined' || xtoken == null) ? '' : xtoken
    if (xtoken !== '') {
      function time(time = +new Date()) {
        var date = new Date(time + 8 * 3600 * 1000); // 增加8小时
        return date.toJSON().substr(0, 19).replace('T', ' ');
      }
      let yToken = {"appCode":"bdks","plat":"pc","time":time(+new Date()),"userToken":xtoken}
      let accessToken =  secret.encrypts(JSON.stringify(yToken),xtoken.slice(0,16)) ;
      config.headers['token'] = xtoken
      config.headers['accessToken'] = accessToken
    }
    xtoken = (xtoken === 'undefined') ? '' : xtoken
    // 管理员身份
    let adminToken = sessionStorage.getItem('adminToken');
    // console.log('adminToken',adminToken); 
    if (config.method === 'post') {
      config.params = {
        token: xtoken,
        ...config.params
      }
      if(adminToken){
        config.params.adminToken = adminToken
      }
    } else if (config.method === 'get') {
      config.params = {
        token: xtoken,
        ...config.params
      }
      if(adminToken){
        config.params.adminToken = adminToken
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// respone拦截器
axiosService.interceptors.response.use(
  response => {
    // console.log(response,response.config.url);
    
    if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
      try {
        // eslint-disable-next-line no-param-reassign
        response.data = JSON.parse(response.request.responseText);
      } catch (e) {
        // ignored
      }
    }
    if (response.data == null && response.config.responseType === 'blob' ) {
      try {
        // eslint-disable-next-line no-param-reassign
        response.data = JSON.parse(response.request.responseText);
      } catch (e) {
        // ignored
      }
    }
    // const loginToken = getUserToken()
    // console.log(response.data);
    
    const resData = response.data
    const errorInfo = resData.errorInfo
    if (errorInfo === 'tokenInvalid') {
      store.dispatch('loginOut').then(res => {
        // window.location.reload()
      }).catch(() => {
      })
    } else if (errorInfo === 'notLogin') {
      // const isLogin = store.getters.isLogin
      // console.log(isLogin, loginToken)
    } else {
    }
    return response
  },
  error => { // 默认除了2XX之外的都是错误的，就会走这里
    if (error.response) {
      switch (error.response.status) {
        case 401:
          /* if (store.state.gameId) {
            store.commit('DELETE_TOKEN'  )
            router.replace({ // 跳转到登录页面
              path: '/login?gameId=' + store.state.gameId,
              query: {redirect: router.currentRoute.fullPath, gameId: store.state.gameId} // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
          } else {
            // store.commit('USER_LOGOUT')
          } */
        case 504:
            //请求超时--没有返回结果
            console.log('errerr',error);
            //超时处理 error.config是一个对象，包含上方create中设置的三个参数
            let config = error.config;
            if (!config || !config.retry) return Promise.reject(error);
          
            // __retryCount用来记录当前是第几次发送请求
            config.__retryCount = config.__retryCount || 0;
          
            // 如果当前发送的请求大于等于设置好的请求次数时，不再发送请求，返回最终的错误信息
            if (config.__retryCount >= config.retry) {
              return Promise.reject(error);
            }
          
            // 记录请求次数+1
            config.__retryCount += 1;
          
            // 设置请求间隔 在发送下一次请求之前停留一段时间，时间为上方设置好的请求间隔时间
            var backoff = new Promise( (resolve) => {
              setTimeout( ()=> {
                resolve();
              }, config.retryDelay || 1);
            });
          
            // 再次发送请求
            return backoff.then( ()=> {
              return axiosService(config);
            });
      }
      return Promise.reject(error.response)
    }else{
      //请求超时--没有返回结果
      console.log('errerr',error);
      //超时处理 error.config是一个对象，包含上方create中设置的三个参数
      var config = error.config;
      if (!config || !config.retry) return Promise.reject(error);
    
      // __retryCount用来记录当前是第几次发送请求
      config.__retryCount = config.__retryCount || 0;
    
      // 如果当前发送的请求大于等于设置好的请求次数时，不再发送请求，返回最终的错误信息
      if (config.__retryCount >= config.retry) {
        return Promise.reject(error);
      }
    
      // 记录请求次数+1
      config.__retryCount += 1;
    
      // 设置请求间隔 在发送下一次请求之前停留一段时间，时间为上方设置好的请求间隔时间
      var backoff = new Promise( (resolve) => {
        setTimeout( ()=> {
          resolve();
        }, config.retryDelay || 1);
      });
    
      // 再次发送请求
      return backoff.then( ()=> {
        return axiosService(config);
      });
    }
  }
)

export default axiosService



// WEBPACK FOOTER //
// ./src/utils/request.js